import { render } from "./CustomIncludesExcludes.vue?vue&type=template&id=0fb4ba03"
import script from "./CustomIncludesExcludes.vue?vue&type=script&lang=js"
export * from "./CustomIncludesExcludes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__